export function convertToObjectById<T>(array: { id: string | number }[]): {
  [id: string | number]: T;
} {
  return array.reduce((obj, item) => {
    const { id } = item;
    obj[id] = item;
    return obj;
  }, {});
}
